export const SHIFT_CHANGE_ROOT_BRANCH = 'shift/change-root-branch';
